<template>
<div class="row">
    <div class="col-12">
        <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                <label for="quantity">收件人姓名</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors.length > 0 }" id="name" name="name" v-model="name" placeholder="請輸入收件人姓名">
                <small class="invalid-feedback">
                    請輸入收件人姓名
                </small>
                </ValidationProvider>
            </div>
            <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                <label for="quantity">收件人地址</label>
                <textarea class="form-control" :class="{ 'is-invalid': errors.length > 0 }" id="address" name="address" rows="5" v-model="address" placeholder="請輸入收件地址"></textarea>
                <small class="invalid-feedback">
                    請輸入收件人地址
                </small>
                </ValidationProvider>
            </div>
            <div class="form-group form-check">
                <input class="form-check-input" type="checkbox" id="set_default_address" name="set_default_address" v-model="set_default_address">
                <label class="form-check-label" for="set_default_address">
                    預設為帳號地址
                </label>
            </div>

            <p>
                <small>請確保收件人姓名及地址準確無誤。如因所提供的郵寄資料錯誤或郵遞失誤而導致寄失或延遲，恕不補發禮品。</small>
            </p>

            <button type="submit" class="btn btn-block btn-speakout" :disabled="invalid">確認</button>
        </form>
        </ValidationObserver>
    </div>
</div>
</template>

<script>
export default {
    name: "address-confirmation",

    props: [
        'user'
    ],

    data() {
        return {
            'name': null,
            'address': this.user.address,
            '[set_default_address]': true
        }
    },

    methods: {
        onSubmit() {
            this.$emit('addressConfirmed', {
                'name': this.name,
                'address': this.address,
                'set_default_address': this.set_default_address
            })
        }
    }
}
</script>

<style>

</style>
